// extracted by mini-css-extract-plugin
export default {"SalesLandingPage__spinner":"umSXc"};